import { render, staticRenderFns } from "./NodeFile.vue?vue&type=template&id=f454bf3e&scoped=true&"
import script from "./NodeFile.vue?vue&type=script&lang=js&"
export * from "./NodeFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f454bf3e",
  null
  
)

export default component.exports